export const ANALYTICS_CACHE_KEYS = {
  EMI_STATS: "emi_monthly_stats",
  ENROLLMENT_STATS: "enrollment_monthly_stats",
  COMPLETION_RATE: "completion_rate",
};

export const POLLING_CONFIG = {
  INITIAL_DELAY: 0,
  REFRESH_INTERVAL: 5 * 60 * 1000,
  ERROR_RETRY_DELAY: 30 * 1000,
  MAX_RETRIES: 3,
};
